import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { AppService } from '../../../../../app.service';
import {
    DashboardPageConstants,
    DashboardFavourites
} from './fecr-dashboard.model';
import { FavouriteDialogComponent } from '../../../favourite-dialog/favourite-dialog.component';
import { GETDashboardService } from '../../../dashboard/dashboard.service';
import { MatDialog } from '@angular/material/dialog';import { FECRDashboardSearch } from '../fecr-search-panel/fecr-search-panel.model';
import { NotificationsService } from 'angular2-notifications';
@Component({
  selector: 'app-fecr-dashboard',
  templateUrl: './fecr-dashboard.component.html',
  styleUrls: ['./fecr-dashboard.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ height: '1px', opacity: 0 }),
                animate('250ms', style({ height: '324px', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '324px', opacity: 1 }),
                animate('250ms', style({ height: '1px', opacity: 0 }))
            ])
        ]
    )],
})
export class FECRDashboardComponent implements OnInit {

// Page constants
pageConstants: DashboardPageConstants = new DashboardPageConstants();

// Search options
searchParameters: FECRDashboardSearch = new FECRDashboardSearch();
showSearch: boolean = false;
hideFavourites: boolean = false;

// Get from server
performSearch: boolean = false;
userFavorites: DashboardFavourites[] = [];
selectedUserFavourites: DashboardFavourites[] = [];

searchResults: FECRDashboardSearch[] = [];
selectedTab = 0;
onEq:boolean=true;
performSearchImp: boolean = false;
emptyFav:boolean=false
constructor(private _appService: AppService,
    private _dashboardService: GETDashboardService,
    public dialog: MatDialog,
    public toastr: NotificationsService, vcr: ViewContainerRef,) {
 
}

ngOnInit() {
    this._appService.setPageTitle(this.pageConstants.PAGE_TITLE);
    //this._appService.setPageSubTitle(this.pageConstants.PAGE_SUBTITLE);

    this.loadFavourites();
}
getOnEquipment() {
    this.onEq= !this.onEq
  }

loadFavourites() {
    this._dashboardService.GetDashboardFavourites().subscribe(result => {
        if (result != null) {
            this.userFavorites = result;
        }
    });
}

showFavorite(favourite) {
    let hasValue = this.selectedUserFavourites.find(x=>x.Id== favourite.Id);
    if(!hasValue){
        this.selectedUserFavourites.push(favourite);
        this.emptyFav=true;
        this.performSearchImp=false;
    }
    this.hidematgroup=false;
}
deleteFavorite(favourite){
    if(favourite.Id>0){
        this._dashboardService.DeleteFavourite(favourite.Id).subscribe(res=>{
            if(res){
                
                this.toastr.success("Deleted successfully");
                this.loadFavourites();
            }else{
                console.log("failed")
            }
        })
    }
    
}
show:boolean=false
hidematgroup:boolean=false


ResetFields(value){
    this.hidematgroup=value;
    this.selectedUserFavourites = [];
}
toggleFavourites() {
    this.hideFavourites = !this.hideFavourites;
}

showSearchPanel(visibility: boolean) {
    this.showSearch = visibility;
}

getSearchFilters(data) {
    console.log("data", data)
    this.searchParameters = data;
    this.performSearch = true;
    this.performSearchImp=true;
    this.hidematgroup=false;
    if (this.searchResults.length == 1 && this.searchParameters !== undefined && this.searchParameters != null) {
        this.searchResults.pop();
        this.searchResults.push(this.searchParameters);
    } else if (this.searchResults.length == 0 && this.searchParameters !== undefined && this.searchParameters != null) {
        this.searchResults.push(this.searchParameters);
    }
}

OpenFavourite(): void {
    let dialogRef = this.dialog.open(FavouriteDialogComponent, {
        disableClose: true,
        data: { }
    });
    dialogRef.afterClosed().subscribe(r => {
        this.loadFavourites();
        if (!r) return;
    });
}



UpdateFavourite(favourite) {
    let dialogRef = this.dialog.open(FavouriteDialogComponent, {
        disableClose: true,
        data: {
            favouriteId: favourite.Id
        }
    });
    dialogRef.afterClosed().subscribe(r => {
        if (r.data != null) {

        } else {

        }
    });
}

}

